module.exports = __webpack_public_path__ + "static/media/no-rojo.9b841803.svg";